import { ThemeEvents } from '@theme/events';

/**
 * Jauge de franco de port — Maison Empereur.
 * Se met à jour quand le panier change : lit event.detail.resource.total_price
 * (CartUpdateEvent), sinon /cart.js. L'état initial vient du Liquid.
 * Les messages (gabarit avec [amount]) sont fournis traduits par le Liquid.
 */
class MeFreeShippingBar extends HTMLElement {
  connectedCallback() {
    this.threshold = parseInt(this.dataset.threshold, 10) || 0;
    this.fill = this.querySelector('.me-franco__fill');
    this.msg = this.querySelector('.me-franco__msg');
    this.onCartUpdate = (event) => {
      // Base = sous-total produits (avant remise panier), cohérent avec le Liquid.
      const subtotal = event?.detail?.resource?.items_subtotal_price;
      if (typeof subtotal === 'number') {
        this.update(subtotal);
      } else {
        this.refresh();
      }
    };
    document.addEventListener(ThemeEvents.cartUpdate, this.onCartUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.cartUpdate, this.onCartUpdate);
  }

  async refresh() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      this.update(cart.items_subtotal_price);
    } catch (_) {
      // silencieux : on garde l'état Liquid
    }
  }

  /** @param {string} cents - montant en centimes → "12,00 €" selon la langue de la page */
  formatAmount(cents) {
    const lang = document.documentElement.lang || 'fr';
    const value = (cents / 100).toLocaleString(lang, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return `${value} €`;
  }

  /** @param {number} totalCents - total du panier en centimes */
  update(totalCents) {
    if (!this.threshold) return;

    const reached = totalCents >= this.threshold;
    const pct = reached ? 100 : Math.max(3, (totalCents / this.threshold) * 100);

    if (this.fill) this.fill.style.width = `${pct}%`;
    this.classList.toggle('me-franco--reached', reached);

    if (!this.msg) return;
    if (reached) {
      this.msg.textContent = this.dataset.msgReached || '';
    } else {
      const amount = this.formatAmount(this.threshold - totalCents);
      const template = this.dataset.msgRemaining || '[amount]';
      // Contenu contrôlé : gabarit traduit (statique) + montant formaté.
      this.msg.innerHTML = template.replace('[amount]', `<strong>${amount}</strong>`);
    }
  }
}

if (!customElements.get('me-free-shipping-bar')) {
  customElements.define('me-free-shipping-bar', MeFreeShippingBar);
}
